// assets/custom-cart.js
(() => {
  const threshold = Number(window.themeSettings?.shippingThreshold ?? 100);
  const STORAGE_KEY = "freeShippingState";

  // Global runtime state (readable anywhere)
  window.freeShipping = window.freeShipping || {
    threshold,
    remainder: null, // don't assume at start
    cartTotal: null, // don't assume at start
    loaded: false,
  };

  const EVENT_NAME = "free-shipping:update";

  function emit() {
    document.dispatchEvent(
      new CustomEvent(EVENT_NAME, {
        detail: { ...window.freeShipping },
      }),
    );
  }

  function persist() {
    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          cartTotal: window.freeShipping.cartTotal,
          remainder: window.freeShipping.remainder,
        }),
      );
    } catch (_) {}
  }

  function hydrateFromStorage() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (
        typeof parsed?.cartTotal !== "number" ||
        typeof parsed?.remainder !== "number"
      )
        return;

      window.freeShipping.cartTotal = parsed.cartTotal;
      window.freeShipping.remainder = parsed.remainder;
      window.freeShipping.loaded = true;
      emit();
    } catch (_) {}
  }

  function setFromCart(cart) {
    const cartTotal = (cart?.total_price ?? 0) / 100;

    window.freeShipping.threshold = threshold;
    window.freeShipping.cartTotal = cartTotal;
    window.freeShipping.remainder = Math.max(0, threshold - cartTotal);
    window.freeShipping.loaded = true;

    persist();
    // console.log("[free-shipping]", window.freeShipping);
    emit();
  }

  // --- Announcement bar integration ---
  function formatMoney(amount) {
    return `$${Number(amount || 0).toFixed(0)}`;
  }

  function renderTemplate(template, detail) {
    return (template || "")
      .replaceAll("[[threshold]]", formatMoney(detail.threshold))
      .replaceAll("[[remaining]]", formatMoney(detail.remainder));
  }

  function updateAnnouncements(detail) {
    const els = document.querySelectorAll("[data-free-shipping-message]");
    if (!els.length) return;

    // IMPORTANT: don't show "progress" until we actually know cart state
    const canShowProgress =
      detail.loaded === true && typeof detail.remainder === "number";
    const cartTotal =
      typeof detail.cartTotal === "number" ? detail.cartTotal : 0;
    const remainder =
      typeof detail.remainder === "number" ? detail.remainder : 0;

    const hasCart = detail.loaded === true; // we actually know cart state
    const isEmpty = hasCart ? cartTotal <= 0 : true; // before load, treat as empty
    const isQualified = hasCart && !isEmpty && remainder <= 0;
    const isInProgress = hasCart && !isEmpty && remainder > 0;

    els.forEach((el) => {
      const msgDefault = el.dataset.messageDefault || "";
      const msgProgress = el.dataset.messageProgress || "";
      const msgQualified = el.dataset.messageQualified || "";

      const template =
        isQualified && msgQualified
          ? msgQualified
          : isInProgress
            ? msgProgress
            : msgDefault;

      el.textContent = renderTemplate(template, {
        ...detail,
        cartTotal,
        remainder,
      });

      el.hidden = false;
    });
  }

  // Listen first so early emits paint UI
  document.addEventListener(EVENT_NAME, (e) => updateAnnouncements(e.detail));

  // Fast paint from cache (prevents navigation flash)
  hydrateFromStorage();

  // If nothing cached, show default immediately (no progress flash)
  if (!window.freeShipping.loaded) {
    emit();
  }

  // Initial load (source of truth)
  fetch("/cart.js")
    .then((r) => r.json())
    .then(setFromCart)
    .catch(() => {});

  // Intercept cart-changing fetch calls
  const originalFetch = window.fetch;

  window.fetch = async function (input, init) {
    const response = await originalFetch(input, init);

    const url = typeof input === "string" ? input : input?.url;
    if (!url) return response;

    const isCartJsonEndpoint =
      url.includes("/cart/add") ||
      url.includes("/cart/change") ||
      url.includes("/cart/update") ||
      url.includes("/cart.js");

    if (!isCartJsonEndpoint) return response;

    const contentType = response.headers.get("content-type") || "";
    if (!contentType.includes("application/json")) return response;

    response
      .clone()
      .json()
      .then((data) => {
        if (typeof data?.total_price === "number") {
          setFromCart(data);
        } else {
          fetch("/cart.js")
            .then((r) => r.json())
            .then(setFromCart)
            .catch(() => {});
        }
      })
      .catch(() => {});

    return response;
  };

  window.freeShippingEventName = EVENT_NAME;
})();
